module.exports = __webpack_public_path__ + "static/media/Brown Astronaut And Space Baby.0af20079.jpg";